// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraPanelTemplate from '@front/templates/TerceraPanelTemplate.html';
import { ContainerControl } from './ContainerControl';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
export class TerceraPanel extends ContainerControl {
    constructor(opts) {
        super(opts);
    }
    getType() {
        return ControlsTypes.TerceraPanel;
    }
    getClientPanel() {
        return this.el;
    }
}
ContainerControl.extendWith(TerceraPanel, {
    template: TerceraPanelTemplate
});
